import { render, staticRenderFns } from "./company-transactions-table.vue?vue&type=template&id=62994332&scoped=true"
import script from "./company-transactions-table.vue?vue&type=script&lang=js"
export * from "./company-transactions-table.vue?vue&type=script&lang=js"
import style0 from "./company-transactions-table.vue?vue&type=style&index=0&id=62994332&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62994332",
  null
  
)

export default component.exports